/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Task_Transition_BodyInputs */

const en_notifications_task_transition_body = /** @type {(inputs: Notifications_Task_Transition_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the activity to see its current status.`)
};

const pt_br2_notifications_task_transition_body = /** @type {(inputs: Notifications_Task_Transition_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra a atividade para ver o status atual.`)
};

/**
* | output |
* | --- |
* | "Open the activity to see its current status." |
*
* @param {Notifications_Task_Transition_BodyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_task_transition_body = /** @type {((inputs?: Notifications_Task_Transition_BodyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Task_Transition_BodyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_task_transition_body(inputs)
	return pt_br2_notifications_task_transition_body(inputs)
});